if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formId = this.querySelector("form").getAttribute("id");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.hasCartDrawer = !!document.querySelector("[data-cart-drawer]");
        this.submitButton = this.querySelector('[type="submit"]');
        //checking if product os elegible for installation or servicing packages
        this.hasPackage = this.submitButton.dataset.productPackage;
        if (this.hasCartDrawer)
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const formData = new FormData(this.form);

        /* custom extended warranty value - START*/
        const extendedWarrantyElement = document.querySelector(
          `.product__extended-warranty[form="${this.formId}"]`
        );

        if (extendedWarrantyElement && extendedWarrantyElement.value !== "") {
          // this.form.querySelector("[name=id]").disabled = true;
          const cartItemData = {
            items: [
              // {
              //   id: this.form.querySelector("[name=id]").value,
              //   quantity: document.querySelector(
              //     `.quantity__input[form="${this.formId}"]`
              //   ).value,
              // },
              {
                id: extendedWarrantyElement.value,
                quantity: document.querySelector(
                  `.quantity__input[form="${this.formId}"]`
                ).value,
                properties: {
                  _related_variant_id:
                    this.form.querySelector("[name=id]").value,
                  "Extended Warranty for":
                    extendedWarrantyElement.dataset.title,
                },
              },
            ],
          };

          // formData.append("items[0][id]", cartItemData.items[0].id);
          // formData.append("items[0][quantity]", cartItemData.items[0].quantity);

          // Add the extended warranty item to the FormData
          formData.append("items[0][id]", cartItemData.items[0].id);
          formData.append("items[0][quantity]", cartItemData.items[0].quantity);
          formData.append(
            "items[0][properties][_related_variant_id]",
            cartItemData.items[0].properties["_related_variant_id"]
          );

          formData.append(
            "items[0][properties][Extended Warranty for]",
            cartItemData.items[0].properties["Extended Warranty for"]
          );

          const timestamp = new Date().toISOString();

          formData.append("items[0][properties][_timestamp]", timestamp);
          formData.append(
            "items[0][properties][NOTE]",
            "If you have multiple products that require this warranty, please make sure you have added warranties for each individual product."
          );
          formData.append("properties[_timestamp]", timestamp);
        }

        /* custom extended warranty value - END */

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        if (this.hasCartDrawer) {
          formData.append("sections", "header");
          formData.append("sections_url", window.location.pathname);
        }
        config.body = formData;

        for (let entry of formData.entries()) {
          console.log(entry);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.hasCartDrawer) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.openCartDrawer(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.openCartDrawer(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            //run function to update packages on cart update
            if (
              typeof updatePackagesOnCartUpdate === "function" &&
              this.hasPackage === "true"
            ) {
              updatePackagesOnCartUpdate();
            }
            if (window.location.pathname.includes("cart")) {
              window.location.reload();
            }
          });
      }

      openCartDrawer(data) {
        const eventBus = window[Symbol.for("xi-theme.eventBus")];
        if (!eventBus) {
          window.location = window.routes.cart_url;
          return;
        }
        eventBus.emit("cart:updated", null, { data, openDrawer: true });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
